import React, { useState, useRef } from 'react';
import axios from "axios";     
import Spinner from '../../../../components/common/Spinner';  
import { MultiSelect } from "react-multi-select-component"; 
import CryptoJS from 'crypto-js';
import moment from 'moment';

const NewSupplier = () => {
   
        const [newRegisterFeedback, setNewRegisterFeedback] = useState("");  
        const [Silulumanzi_Employee, setSilulumanzi_Employee] = useState("");
        const [Silulumanzi_Recent_Employee, setSilulumanzi_Recent_Employee] = useState("");
        const [Silulumanzi_Employee_Relative, setSilulumanzi_Employee_Relative] = useState("");
        const [Silulumanzi_Official_Relationship, setSilulumanzi_Official_Relationship] = useState("");
        const [Voluntary_Disclosure, setVoluntary_Disclosure] = useState(""); 
        const [Hazardous_Substances, setHazardous_Substances] = useState("");
        const [registerFeedback, setRegisterFeedback] = useState("");  
        const [businessType, setBusinessType] = useState([]);
        const [attachments, setAttachments] = useState({});
        const [services, setServices] = useState([]);
        const [registerOTP, setRegisterOTP] = useState(false);  
        const [reference, setReference] = useState(0);  
        const [progress, setProgress] = useState(0); 
        const [formDataObject, setFormDataObject] = useState({}); 
        const [formFiles, setFormFiles] = useState({});  
        const [selected, setSelected] = useState([]);
        const [step, setStep] = useState(1); 
        const sess = btoa(moment().format('YYYY-MM-DD'));
        const formRef = useRef();
        

        const CryptoJSAesJson = {
            stringify: function (cipherParams) {
                var j = {ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64)};
                if (cipherParams.iv) j.iv = cipherParams.iv.toString();
                if (cipherParams.salt) j.s = cipherParams.salt.toString();
                return JSON.stringify(j);
            },
            parse: function (jsonStr) {
                var j = JSON.parse(jsonStr);
                var cipherParams = CryptoJS.lib.CipherParams.create({ciphertext: CryptoJS.enc.Base64.parse(j.ct)});
                if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv)
                if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s)
                return cipherParams;
            }
        }

        const handleSupplierRegisterSubmit = async (e) => { 
            e.preventDefault();
            setRegisterFeedback(<Spinner
                size={80}
                color="#4fa94d"
                center={true}
                /> );

            if(!registerOTP){
                const formData = new FormData();   
                const form = new FormData(e.currentTarget);  
                const formDataObj = {};
                form.forEach((value, key) => (formDataObj[key] = value));  
                var encrypted = CryptoJS.AES.encrypt(JSON.stringify(formDataObj), sess, {format: CryptoJSAesJson}).toString();
                formData.append("payload", encrypted);     
                try {
                    const response = await axios.post(process.env.REACT_APP_API_BASE_URL + "supplier/register/", formData).then(function (response) { 
                            if (response.data !== undefined &&
                            response.data.status === 1) { 
                                setRegisterFeedback("A one time pin has been sent to your email address"); 
                                setRegisterOTP(true);
                            }
                            else 
                            {
                                setRegisterFeedback(response.data.message);
                            }
                    });
                        
                }
                catch (error) {
                    setRegisterFeedback("There seems to be a technical glitch. Please try again later.");                    
                }   
            }  
            
            else
            {
                const formData = new FormData();   
                const form = new FormData(e.currentTarget);    
                const formDataObj = {};
                form.forEach((value, key) => (formDataObj[key] = value));

                if(formDataObj.pin == ""){
                    setRegisterFeedback("You cannot submit an empty OTP!"); 
                }
                else{
                    var encrypted = CryptoJS.AES.encrypt(JSON.stringify(formDataObj), sess, {format: CryptoJSAesJson}).toString();
                    formData.append("payload", encrypted);     
                    try {
                        const response = await axios.post(process.env.REACT_APP_API_BASE_URL + "supplier/register/", formData).then(function (response) {  
                            if (response.data !== undefined &&
                            response.data.status === 1) {  
                                setRegisterFeedback("OTP Verified. Logging you in..."); 
                                setTimeout(() => {
                                    window.location.replace(process.env.REACT_APP_API_BASE_URL + "supplier/authenticated/"+response.data.token); 
                                }, 2000);   
                            }
                            else 
                            {
                                setRegisterFeedback(response.data.message);
                            }
                        });                     
                    }
                    catch (error) {
                        setRegisterFeedback("There seems to be a technical glitch. Please try again later.");                    
                    }  
                }
        
            }  
        }

    const handleNewSupplierSubmit = async (e) => { 
        e.preventDefault(); 
        if(step == 2)
        {
          let data = new FormData(e.target); 
          try {
              const response = await axios.post(process.env.REACT_APP_API_BASE_URL + "api/start_application/", data).then(function (response) {
                  if (response.data !== undefined && response.data.status === 1) {
                      if (response.data !== undefined && response.data.status === 1) { 
                          setServices(response.data.services); 
                          setReference(response.data.reference);

                          setStep(step + 1);
                          setProgress(progress + 20); 
                          let data = new FormData(e.target);
                          let formObject = Object.fromEntries(data.entries());
                          let dataObject = Object.assign({}, formObject, formDataObject);
                          setFormDataObject(dataObject);  
                      } 
                  } 
                  else {
                    setNewRegisterFeedback(response.data.message);
                  }
              });
          }
          catch (error) { 
              console.log(error);
          } 
        } 
        
        if(step == 4)
        {
         
          let file_check = {}; 

          for(let index in attachments)
          {
              const formData = new FormData();
              if(attachments[index].name != undefined)
              {
                  file_check[index] = "1";
                    formData.append(
                      "file",
                      attachments[index],
                      attachments[index].name
                  );

                  let name = businessType[index] != undefined ? businessType[index] : index; 

                  formData.append("reference",reference); 
                  formData.append("name", name);

                  axios.post(process.env.REACT_APP_API_BASE_URL + "api/upload_file", formData).then(function (response) {
                    if(response.data.status == 1)
                    {         
                      file_check[index] = 2;
                    }
                });
              } 
              else
              {
                file_check[index] = "0";
              }  
          } 
          
          setFormFiles(file_check);
        }
        
        if(step < 5 && step != 2)
        {  
          setStep(step + 1);
          setProgress(progress + 20); 
          let data = new FormData(e.target);
          let formObject = Object.fromEntries(data.entries());
          let dataObject = Object.assign({}, formObject, formDataObject);
          setFormDataObject(dataObject);  
        } 
        else
        {
          try {
            let data = new FormData();
            data.append("reference", reference);
            data.append("Group_Code", selected.map(a => a.value).toString());
            
            for ( var key in formDataObject ) {
                data.append(key, formDataObject[key]);
            }

            const response = await axios.post(process.env.REACT_APP_API_BASE_URL + "api/start_application/", data).then(function (response) {
              if (response.data !== undefined && response.data.status === 1) {

                  let data = new FormData(e.target);
                  data.append("reference", reference);
                  data.append("profile", formDataObject);
                  data.append("files", JSON.stringify(businessType));
                  data.append("services", selected.map(a => a.value)); 
                  data.append("attached", JSON.stringify(formFiles));
                
                    axios.post(process.env.REACT_APP_API_BASE_URL + "api/complete_application/", data).then(function (response) {
                    if (response.data !== undefined && response.data.status === 1) {                      
                        setStep(step + 1);
                        setProgress(progress + 20);                    
                    } 
                });
              } 
          }); 
        }
        catch (error) { 
            console.log(error);
        }
      }   
    }


    return ( 
        <> 
        <form 
        onSubmit={handleNewSupplierSubmit} 
        ref={formRef} 
        className="suppler-registration-form">
        
        {newRegisterFeedback != "" ? (
            <p className="alert alert-warning mb-3">{newRegisterFeedback}</p>
        ) : (
            <></>
        )}
                Step {step} of 6
                <div className="progress">
                <div
                    className="progress-bar progress-bar-success"
                    role="progressbar"
                    aria-valuenow="1"
                    aria-valuemin="1"
                    aria-valuemax="4"
                    style={{width: `${progress}%`}}
                >                       
                </div>
                </div> 
                {step == 1 ? 
                <div className="terms-and-conditions">
                <h3>INTRODUCTION</h3>
                <p>
                Silulumanzi hereby invites current and prospective suppliers to apply to be verified and registered on the Company Supplier Database. Henceforth, Silulumanzi will not do business with suppliers that are not validated and registered on the database. Suppliers currently doing business with Silulumanzi must register in terms of this new process through the <strong>Portal Signup</strong> option.
                </p>
                <h4>Instructions to Suppliers:</h4>
                <ol>
                <li>The online application form must be completed in full.</li>
                <li>All the required and supporting documentation must be submitted attached before submitting.</li>
                <li>Failure to submit supporting and requested information will lead to your company not being registered.</li>   
                <li>It is compulsory to complete Products and/or Services section on <strong>Step 3</strong>. You may select up to 5 services</li>
                <li>Trade Experience section on <strong>Step 4</strong> on must be completed in full to give Silulumanzi an understanding of whether your firm has experience of supplying the products and services your firm is applying for.</li>
                <li>Declaration by business on <strong>Step 5</strong> is compulsory and must be completed in full by all suppliers. Failure to comply with the requirement will lead to your company not being registered.</li>
                <li>Silulumanzi reserves the right to validate all information supplied and any misrepresentation of facts may lead to disqualification and potentially being restricted to do business with Silulumanzi in future.</li>
                <li>For assistance on how to complete the form or any other query related to this process please contact the Procurement section on (013) 752 6839.</li>
                <li>Silulumanzi will inform suppliers of the status of their application in writing/email.</li>
                </ol>
                <div className="mb-3">         
                        <a className="btn btn-success float-end" 
                        onClick={() => { 
                        setStep(2);
                        setProgress(20);
                        }} >
                        Continue
                        </a>
                </div> 
                </div> : ""}

                {step == 2 ?   
                <div>
                <div className="form-group mb-4">
                <label>
                    Business Type
                </label>
                <div className="input-group">
                    <select name="Business_Type" className="form-select" 
                    onChange={(e) => {
                        if(e.target.value != ""){
                        let files = e.target.value.split("|");
                        setBusinessType(files);
                        let attach = {};

                        files.forEach((file, i) => {
                            attach[i] = {};
                        });

                        setAttachments(attach); 

                        }else{
                        setBusinessType([]);
                        }                          
                        }}> 
                    <option value="">Please Select</option>
                    <option value="Certificate of incorporation CK1
                    |Latest Copy of Rates & Taxes Statement or Lease agreement or Municipal/ Silulumanzi Account
                    |Valid SARS TAX Pin Certificate
                    |Clear Certified ID Copies (not older than 3 months) of Members
                    |Valid BBBEE Certificate
                    |Proof of Banking">Close Corporation</option>
                    <option value="Duly Signed Partnership Agreement
                    |Latest Copy of Rates & Taxes Statement or Lease agreement or Municipal/ Silulumanzi Account
                    |Valid Partnership Pin Tax Certificate
                    |Clear Certified ID Copies (not older than 3 months) of Partners
                    |Valid BBBEE Certificate
                    |Proof of Banking">Partnership</option>
                    <option value="Certificate of Incorporation COR 14.1 
                    |Latest Copy of Rates & Taxes Statement or Lease agreement or Municipal/ Silulumanzi Account
                    |Valid SARS TAX Pin Certificate
                    |Clear Certified ID Copies (not older than 3 months) of Partners
                    |Valid BBBEE Certificate/ Sworn Affidavit
                    |Proof of Banking">Public Company Ltd</option>
                    <option value="Certificate of Incorporation COR 14.3 
                    |Latest Copy of Rates & Taxes Statement or Lease agreement or Municipal/ Silulumanzi Account
                    |Valid SARS TAX Pin Certificate
                    |Clear Certified ID Copies (not older than 3 months) of Partners
                    |Valid BBBEE Certificate/ Sworn Affidavit
                    |Proof of Banking">Private Company (Pty) Ltd</option>
                    <option value="Deed of Trust Agreement
                    |Latest Copy of Rates & Taxes Statement or Lease agreement or Municipal/ Silulumanzi Account
                    |Valid SARS TAX Pin Certificate
                    |Clear Certified ID Copies (not older than 3 months) of Trustees
                    |Valid BBBEE Certificate
                    |Proof of Banking">Business Trust</option>
                    <option value="Certificate of Incorporation Section 21
                    |Latest Copy of Rates & Taxes Statement or Lease agreement or Municipal/ Silulumanzi Account
                    |Valid NPO Pin Tax Certificate / Proof of Exemption
                    |Clear Certified ID Copy (not older than 3 months)
                    |Valid BBBEE Certificate
                    |Proof of Banking">Non-Profit Organisation</option>
                    <option value="Registrar of Close Corporation & Companies
                    |Local Authority
                    |Receiver of Revenue (SARS)">Institution</option>
                    </select> 
                </div>
                </div>
                {businessType.length > 0 ? 
            <div className="alert alert-info services"> 
                <h6>Please ensure you have the documents listed below before proceeding:</h6>
                <ul>
                {businessType.map((item, index) => {
                    return (
                    <li key={index}>{item}</li>
                    );
                })}
                </ul></div> : null}
            
                <hr/>

                <div className="row">
                <div className="col-md-6">                      
                    <div className="form-group mb-3">
                    <label>
                        Business Classification
                    </label>
                    <div className="input-group">
                        <select name="Business_Type" className="form-select" onChange={(e) => {}}>
                        <option>Original Equipment Manufacturer (OEM)</option>
                        <option>Manufacturer</option>
                        <option>Distributor/ Supplier/Agent</option>
                        <option>Professional Service Provider</option>
                        </select> 
                    </div>
                    </div>   

                    <div className="form-group mb-3">
                    <label>
                        Registered Company Name
                    </label>
                    <div className="input-group">
                        <input
                        type="text"
                        name="Company_Registered_Name"
                        className="form-control" 
                        required
                        />
                    </div>
                    </div>

                    <div className="form-group mb-3">
                    <label>
                        Holding Company Name
                    </label>
                    <div className="input-group">
                        <input
                        type="text"
                        name="Holding_Company_Name"
                        className="form-control" 
                        required
                        />
                    </div>
                    </div>                                         

                    <div className="form-group mb-3">
                    <label>
                        Trading Company Name
                    </label>
                    <div className="input-group">
                        <input
                        type="text"
                        name="BP_Name"
                        className="form-control" 
                        required
                        />
                    </div>
                    </div>

                    <div className="form-group mb-3">
                    <label>
                        Company Registration
                    </label>
                    <div className="input-group">
                        <input
                        type="text"
                        name="Company_Reg"
                        className="form-control"  
                        required 
                        />
                    </div>
                    </div>

                    
                    <div className="form-group mb-3">
                    <label>
                        Vat Registration Number
                    </label>
                    <div className="input-group">
                        <input
                        type="text"
                        name="Vat_Registration"
                        className="form-control"  
                        />
                    </div>
                    </div>

                    <div className="form-group mb-3">
                    <label>
                        Site/Branch Name
                    </label>
                    <div className="input-group">
                        <input
                        type="text"
                        name="Supplier_Site"
                        className="form-control" 
                        required 
                        />
                    </div>
                    </div>

                    <div className="form-group mb-3">
                    <label>
                        Contact Person
                    </label>
                    <div className="input-group">
                        <input
                        type="text"
                        name="Contact_Person"
                        className="form-control" 
                        required
                        />
                    </div>
                    </div>

                    <div className="form-group mb-3">
                    <label>
                        Business Email Address
                    </label>
                    <div className="input-group">
                        <input
                        type="text"
                        name="E_Mail"
                        className="form-control" 
                        required
                        />
                    </div>
                    </div>

                    <div className="form-group mb-3">
                    <label>
                        Business Website
                    </label>
                    <div className="input-group">
                        <input
                        type="text"
                        name="Business_Web_Address" 
                        className="form-control"  
                        />
                    </div>
                    </div> 

                </div>
                <div className="col-md-6"> 
                    <div className="form-group mb-3">
                    <label>
                        Telephone Number
                    </label>
                    <div className="input-group">
                        <input
                        type="text"
                        name="Tel"
                        className="form-control"  
                        />
                    </div>
                    </div>

                    <div className="form-group mb-3">
                    <label>
                        Mobile Number
                    </label>
                    <div className="input-group">
                        <input
                        type="text"
                        name="Mobile_Phone"
                        className="form-control" 
                        required
                        />
                    </div>
                    </div>

                    <div className="form-group mb-3">
                    <label>
                        Physical Address
                    </label>
                    <div className="input-group">
                        <input
                        type="text"
                        name="Address"
                        className="form-control" 
                        required
                        />
                    </div>
                    </div> 

                    <div className="form-group mb-3">
                    <label>
                        City
                    </label>
                    <div className="input-group">
                        <input
                        type="text"
                        name="City"
                        className="form-control" 
                        required
                        />
                    </div>
                    </div>  

                    <div className="form-group mb-3">
                    <label>
                        Country
                    </label>
                    <div className="input-group">
                    <input name="Country" className="form-control" value="South Africa" type="text" /> 
                    </div>
                    </div>  

                    <div className="form-group mb-3">
                    <label>
                        How do you prefer to be contacted?
                    </label>
                    <div className="input-group">
                        <select name="Preferred_Correspondence_Method" className="form-select" onChange={(e) => {}}> 
                        <option>Email</option>
                        <option>Phone</option> 
                        </select> 
                    </div>
                    </div>        

                    <div className="form-group mb-3">
                    <label>
                    Do you give Settlement Discount if payment is made within 30 days?
                    </label>
                    <div className="input-group">
                        <select name="Settlement_Discount" className="form-select" onChange={(e) => {}}> 
                        <option>No</option>
                        <option>Yes</option> 
                        </select> 
                    </div>
                    </div>  

                    <div className="form-group mb-3">
                    <label>
                        How many percent discount do you give?
                    </label>
                    <div className="input-group">
                        <input
                        type="number"
                        name="Settlement_Discount_Percentage"
                        className="form-control percent"  
                        /><span className="input-group-text">%</span>
                    </div>
                    </div>       
                </div>

                {newRegisterFeedback != "" ? (
                    <p className="alert alert-warning mb-3">{newRegisterFeedback}</p>
                    ) : (
                    <></>
                    )} 

                    <div className="mb-3"> 
                        {businessType.length > 0 ?
                        <button type="submit" className="btn btn-success float-end">
                            Continue
                        </button> : "" }
                </div> 

                
                </div></div> : "" } 

                {step == 3 ? 
                <div>                       
                    <h4>Select Services</h4> 
                    <span><strong>You may select up to <span className="badge bg-primary">5</span> services</strong></span>
                    <div className='services'>
                    {selected.map((service, index) => (
                    index < 5 ? 
                    <div key={index} className='selected_services'>
                        <span className='badge bg-success'>{index + 1}: {service.value}</span>  
                    </div> : <p key={index + 1} className='badge bg-danger'>You have exceeded the maximum number of services</p>
                    ))}

                    <MultiSelect
                    options={services}
                    value={selected}
                    onChange={setSelected}
                    labelledBy="Select"
                    hasSelectAll={false}
                    />
                </div>
                <div className="mb-3">   
                <hr/> 
                    <button className="btn btn-light"  
                        onClick={() => {  
                        setStep(step - 1);
                        setProgress(progress - 20);                              
                        }} >
                        Back
                    </button>

                        { 
                        selected.length > 0 && selected.length <= 5 ?
                        <button type="submit" className="btn btn-success float-end">
                            Continue
                        </button> : "" }
                </div> 
                </div> : ""}

                {step == 4 ? 
                <div>                       
                    <h4>Upload Documents</h4>  
                    <div className="alert alert-info mb-3">
                    Validity of documents; <strong>BEE certificate:</strong> not older than 12 months, <strong>Proof of banking:</strong> Should be provided on relevant bank letterhead (not older than six months from the date of issue), <strong>Tax Clearance certificate:</strong> A valid Tax Clearance Certificate (not older than 12 months)
                    </div>

                    { businessType.map((item, index) => {
                    return (
                    <div key={index}><div className="attach"> 
                    <div className='input-group'> 
                        <label className="text-bg-success">{item}</label>
                        <input type="file" className="form-control" id="inputGroupFile01" onChange={(event)=> {   
                            let attach = attachments;
                            attach[index] = event.target.files[0];
                            setAttachments(attach);
                        }}/>
                    </div> 

                    { item.includes("Tax Certificate") ?
                        <div className="row mb-4">
                        <div className="col-md-6">
                            <label>Tax Certification Number</label>
                            <input
                            type="text"
                            name="Tax_Certification_Number"
                            className="form-control" 
                            required 
                            />
                        </div>

                        <div className="col-md-6">
                            <label>Tax Certificate Expiry Date</label>
                            <input
                            type="date"
                            name="Tax_Certificate_Expiry_Date"
                            className="form-control"  
                            required 
                            />
                        </div>                           
                        </div>: "" }
                        
                        { item.includes("BEE Certificate") ?
                        <div className="row mb-4">
                        <div className="col-md-4">
                            <label>BBBEE Type</label>
                            <input
                            type="text"
                            name="BBBEE_Type"
                            className="form-control" 
                            required 
                            />
                        </div>

                        <div className="col-md-4">
                            <label>BBBEE Level</label>
                            <input
                            type="text"
                            name="BBBEE_Level"
                            className="form-control"  
                            required 
                            />
                        </div>      

                        <div className="col-md-4">
                            <label>BBBEE Expiration Date</label>
                            <input
                            type="date"
                            name="BBBEE_Expiration_Date"
                            className="form-control"  
                            required 
                            />
                        </div>     
                                            
                        </div>: "" }
                    
                        </div>
                    </div>
                    );
                })} 

                

                {formDataObject.Vat_Registration != "" ? 
                <div className='attach'>
                <div className='input-group'> 
                <label className="text-bg-success">Vat Registration Document</label>
                <input type="file" className="form-control" id="inputGroupFile01" onChange={(event)=> {   
                        let attach = attachments;
                        attach["VAT Registration Certificate"] = event.target.files[0];
                        setAttachments(attach);
                }}/>
                </div></div> : "" }

                <div className='attach'>
                    <div className='input-group'> 
                    <label className="text-bg-success">Coida Certificate <span className="badge badge-warning">If Available</span></label>
                    <input type="file" className="form-control" id="inputGroupFile01" onChange={(event)=> {   
                            let attach = attachments;
                            attach["COIDA Registration Certificate"] = event.target.files[0];
                            setAttachments(attach);
                    }}/>
                    </div>                       

                    <div className="row mb-4">
                    <div className="col-md-6">
                        <label>Coida Certificate Number</label>
                        <input
                        type="text"
                        name="COIDA_Certificate_Number"
                        className="form-control"  
                        />
                    </div>

                    <div className="col-md-6">
                        <label>Coida Certificate Expiry Date</label>
                        <input
                        type="date"
                        name="COIDA_Certificate_Expiry_Date"
                        className="form-control"  
                        />
                    </div>                           
                </div>

                </div>
                <hr/> 
                    <button className="btn btn-light"  
                        onClick={() => {  
                        setStep(step - 1);
                        setProgress(progress - 20);                              
                        }} >
                        Back
                    </button>

                <div className="services mb-3">   
                        <button type="submit" className="btn btn-success float-end">
                            Continue
                        </button>
                </div> 
                </div> : ""}

                {step == 5 ? 
                <div className="services declaration">                       
                    <h4>Declaration of any conflict of interest</h4>  
                    <hr/>
                    <div className='fom-group mb-3'>
                    <label className="alert alert-warning mb-2">Are you currently working as an employee in Silulumanzi and/or related company?</label>
                    <select name="Declare_Silulumanzi_Employee" className="form-select" 
                    onChange={(e) => { setSilulumanzi_Employee(e.target.value); }}>
                        <option>No</option>
                        <option>Yes</option>
                    </select>    
                    <input type="hidden" name="Declare_Silulumanzi_Employee_Text" value="Are you currently working as an employee in Silulumanzi and/or related company?" />                      
                    </div>
                    { Silulumanzi_Employee == "Yes" ? 
                    <div className='fom-group mb-3'>
                    <label className="mb-2">Please provide details</label>
                    <textarea className="form-control" name="Declare_Silulumanzi_Employee_Details"></textarea>                     
                </div>
                    :"" }
                <hr/>

                    <div className='fom-group'>
                    <label className="alert alert-warning mb-2">Have you worked in Silulumanzi and/or related company * for the past 12 months?</label>                          
                    <select name="Declare_Silulumanzi_Recent_Employee" className="form-select" 
                    onChange={(e) => { setSilulumanzi_Recent_Employee(e.target.value); }}>
                        <option>No</option>
                        <option>Yes</option>
                    </select>     
                    <input type="hidden" name="Declare_Silulumanzi_Recent_Employee_Text" value="Have you worked in Silulumanzi and/or related company * for the past 12 months?" />                 
                    </div>
                    { Silulumanzi_Recent_Employee == "Yes" ? 
                    <div className='fom-group mb-3'>
                    <label className="mb-2">Please provide details</label>
                    <textarea className="form-control" name="Declare_Silulumanzi_Recent_Employee_Details"></textarea>                     
                </div>
                    :"" }
                    <hr/>                              

                    <div className='fom-group'>
                    <label className="alert alert-warning mb-2">Do you have any relative working for Silulumanzi and/or related company?</label> 
                    <select name="Declare_Silulumanzi_Employee_Relative" className="form-select" 
                    onChange={(e) => { setSilulumanzi_Employee_Relative(e.target.value); }}>
                        <option>No</option>
                        <option>Yes</option>
                    </select>              
                    <input type="hidden" name="Declare_Silulumanzi_Employee_Relative_Text" value="Do you have any relative working for Silulumanzi and/or related company?" />            
                    </div>
                    { Silulumanzi_Employee_Relative == "Yes" ? 
                    <div className='fom-group mb-3'>
                    <label className="mb-2">Please provide details</label>
                    <textarea className="form-control" name="Declare_Silulumanzi_Employee_Relative_Details"></textarea>                     
                </div>
                    :"" }
                    <hr/>

                    <div className='fom-group'>
                    <label className="alert alert-warning mb-2">Do you have any close relationship with any official working in our establishment (except for the above)?</label>
                    <select name="Declare_Silulumanzi_Official_Relationship" className="form-select" 
                    onChange={(e) => { setSilulumanzi_Official_Relationship(e.target.value); }}>
                        <option>No</option>
                        <option>Yes</option>
                    </select>   
                    <input type="hidden" name="Declare_Silulumanzi_Official_Relationship_Text" value="Do you have any close relationship with any official working in our establishment (except for the above)?" />                       
                    </div>

                    { Silulumanzi_Official_Relationship == "Yes" ? 
                    <div className='fom-group mb-3'>
                    <label className="mb-2">Please provide details</label>
                    <textarea className="form-control" name="Declare_Silulumanzi_Official_Relationship_Details"></textarea>                     
                </div>
                    :"" }
                    <hr/>

                    <div className='fom-group'>
                    <label className="alert alert-warning mb-2">Is there any other relevant information that you would like to disclose?</label>
                    <select name="Declare_Voluntary_Disclosure" className="form-select" 
                    onChange={(e) => { setVoluntary_Disclosure(e.target.value); }}>
                        <option>No</option>
                        <option>Yes</option>
                    </select> 
                    <input type="hidden" name="Declare_Voluntary_Disclosure_Text" value="Is there any other relevant information that you would like to disclose?" />                         
                    </div>  
                    { Voluntary_Disclosure == "Yes" ? 
                    <div className='fom-group mb-3'>
                    <label className="mb-2">Please provide details</label>
                    <textarea className="form-control" name="Declare_Voluntary_Disclosure_Details"></textarea>                     
                </div>
                    :"" }                      
                    <hr/>

                    <h4>Quality, Safety and Environment</h4>
                    <hr/>
                    <div className='fom-group'>
                    <label className="alert alert-warning mb-2">Do you have an Environmental Policy in place?</label>
                    <select name="Safety_Environmental_Policy" className="form-select" 
                    onChange={(e) => {}}>
                        <option>No</option>
                        <option>Yes</option>
                    </select>  
                    <input type="hidden" name="Safety_Environmental_Policy_Text" value="Do you have an Environmental Policy in place?" />                        
                    </div> 
                    <hr/>

                    <div className='fom-group'>
                    <label className="alert alert-warning mb-2">Does your facility routinely work with any hazardous substances?</label>
                    <select name="Safety_Hazardous_Substances" className="form-select" 
                    onChange={(e) => { setHazardous_Substances(e.target.value); }}>
                        <option>No</option>
                        <option>Yes</option>
                    </select>    
                    <input type="hidden" name="Safety_Hazardous_Substances_Text" value="Does your facility routinely work with any hazardous substances?" />                      
                    </div>

                    { Hazardous_Substances == "Yes" ? 
                    <div className='fom-group mb-3'>
                    <label className="mb-2">Please provide details</label>
                    <textarea className="form-control" name="Safety_Hazardous_Substances_Details"></textarea>                     
                    </div>
                    :"" }
                    <hr/>   

                    <button type="submit" className="btn btn-success float-end">
                    Submit
                    </button> 
                        
                </div> : ""}

                </form>

                {step == 6 ? 
                <div>                       
                <h5>Your application has been submitted.</h5>    
                <p>
                Thank you for your interest in working with us.
                </p>
                <p className="mb-3">
                    Once your application has been reviewed, you will receive an email confirming your registration.
                </p> 
                <hr></hr>
                <h4>Supplier Portal Registration</h4>  
                    {registerFeedback != "" ? (
                        <p className="alert alert-info mb-3">{registerFeedback}</p>
                    ) : (
                        <></>
                    )}
                <div className="row mt-3">
                    <div className="col-md-6">
                    <form onSubmit={handleSupplierRegisterSubmit}>                         

                    <div style={registerOTP === true ? { display: "none" } : {}}>
                        <div className="form-group mb-3">
                        <label className="label">Reference Number</label>
                        <input
                            name="vendor"
                            type="text"
                            className="form-control" 
                            value={reference}
                            readOnly 
                        />
                        </div>

                        <div className="form-group mb-3">
                        <label className="label">Email Address</label>
                        <input
                            name="email"
                            type="email"
                            className="form-control" 
                            value={formDataObject.E_Mail} 
                            readOnly 
                        />
                        </div>
                    </div>

                    <div style={registerOTP === false ? { display: "none" } : {}}>
                        <div className="form-group mb-3">
                        <label className="label">Enter OTP Below</label>
                        <input name="pin" type="text" className="form-control" />
                        </div>
                    </div>

                    <div className="btn-group mb-3">
                        <button type="submit" className="btn btn-success">
                        Submit
                        </button>
                    </div>
                    </form>
                    </div>
                    </div>
                {}  
            </div> : ""}
        </>
    )
};

export default NewSupplier; 